import * as React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { HeaderCustomer, Navigation } from "@payright/web-components";
import { CUSTOMER_MENU_ITEMS, SUB_MENU_ACTIONS } from "../../util/constants/types";
import { Notifications } from "../Notifications/Notifications";

export { default as NavNotLoggedIn } from "./NotLoggedIn";

type NavProps = {
  title: string;
  activePage: string;
  component?: React.ReactNode;
  previousPagePath?: string;
  subtitle?: string;
};

export const Nav: React.FC<Pick<NavProps, "activePage">> = ({activePage}) => {
  const {notification, remediationDetails} = useSelector((state: any) => ({
    notification: state.pageData.notification,
    remediationDetails: state.pageData.remediationDetails,
  }));
  
  const menuItems = CUSTOMER_MENU_ITEMS.map((menuItem) =>
    menuItem.subMenu
      ? {
          ...menuItem,
          subMenu: remediationDetails?.isRemediationRequired
            ? menuItem.subMenu
            : menuItem.subMenu.filter((item) => item.link !== "/bank-details"),
        }
      : menuItem,
  );

  return (
    <Navigation
      LinkComponent={Link}
      breakpoint="wide"
      portalType="customer"
      menuItems={menuItems}
      activePage={activePage}
      accountDetailsActions={SUB_MENU_ACTIONS}
      notifications={Notifications(notification)}
    />
  );
};

export const NavWithComponent: React.FC<NavProps> = ({title, activePage, component, previousPagePath, subtitle}) => (
  <div className="customer-navigation">
    <Nav activePage={activePage} />
    <HeaderCustomer title={title} previousPagePath={previousPagePath} subtitle={subtitle} LinkComponent={Link} viewPreviousLink={previousPagePath !== undefined} />
  </div>
);
